// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bulk-upload-header .mdi-chevron-left:before{font-weight:bolder}.bulk-upload-header .steps-container{align-items:center;display:flex}.bulk-upload-header .custom-border{border:1px solid #dadada!important}.bulk-upload-header .disable-button{pointer-events:none}.bulk-upload-header .disable-button:active,.bulk-upload-header .disable-button:focus{box-shadow:none!important;outline:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
